// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"264":"b5935703","982":"b5935703"}[chunkId] + ".chunk.css";
};